import { FOOTER } from "@/constants/testIds";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_dev-nexus-play/artifacts/q14fzpwq_um_software_logo_white.png";

export default function Footer() {
  return (
    <footer
      data-testid={FOOTER.section}
      className="relative border-t border-cyan-900/40 bg-[#040404]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-8 py-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
        <div className="flex items-center gap-4">
          <span className="w-14 h-14 flex items-center justify-center border border-cyan-500/60 bg-[#0a0a0a] p-0.5">
            <img src={LOGO_URL} alt="UM Software" className="w-full h-full object-contain" loading="lazy" />
          </span>
          <div>
            <div className="font-mono-display text-base tracking-widest text-slate-100">
              UM<span className="text-cyan-400">/</span>SOFTWARE
            </div>
            <div className="font-hud text-slate-500 mt-1">software.studio · Jakarta · ID</div>
          </div>
        </div>

        <div className="font-hud text-slate-500">
          © {new Date().getFullYear()} UM Software · PT Usaha Muda Cipta Teknologi
        </div>

        <div className="flex items-center gap-4">
          <a
            href="mailto:contact@umsoftware.id"
            className="nav-link"
            data-testid="footer-email-link"
          >
            contact@umsoftware.id
          </a>
        </div>
      </div>
    </footer>
  );
}
